// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5491b2ce","457":"9744e9ed","498":"9635d1e3","551":"65f1010c","619":"24a235c0","627":"c160f975","732":"a38800b4","796":"fe6036d7","851":"d81693d0","977":"9bac61a3"}[chunkId] + ".chunk.js";
};